import type { ReactElement } from 'react';

import useColorTheme from '@/Providers/AppBoundary/use-color-theme';

import ConfirmModalProvider from '../ConfirmModalProvider';
import ToastProvider from '../ToastProvider';

import AppMeta from './AppMeta';

type Props = {
  readonly children: ReactElement;
};

const AppBoundary = ({ children }: Props) => {
  useColorTheme();

  return (
    <>
      <AppMeta />
      <ConfirmModalProvider>
        <ToastProvider>{children}</ToastProvider>
      </ConfirmModalProvider>
    </>
  );
};

export default AppBoundary;
